export type ResourceCategory =
  | "platform-guide"
  | "client-marketing"
  | "webinars"

export type TrainingFile = {
  name: string
  type: "pdf" | "video" | "image"
  url: string
  title: string
  category: ResourceCategory
}

const BASE_URL =
  "https://as.signaturestaycollection.com/signaturestaycollection/Resources"

// Same files served with `Content-Disposition: attachment` so they download
// instead of opening in the browser
const DOWNLOAD_BASE_URL =
  "https://as.signaturestaycollection.com/signaturestaycollection/ResourcesV"

export const getDownloadUrl = (url: string) =>
  url.replace(BASE_URL, DOWNLOAD_BASE_URL)

export const trainingFiles: TrainingFile[] = [
  // Platform Training Guides
  {
    category: "platform-guide",
    title: "Platform Training Guides",
    name: "Booking Directly for a client",
    type: "video",
    url: `${BASE_URL}/1_Platform_Training_Guides/Booking_Directly_for_a_Client.mp4`,
  },
  {
    category: "platform-guide",
    title: "Platform Training Guides",
    name: "Downloading invoices",
    type: "video",
    url: `${BASE_URL}/1_Platform_Training_Guides/Downloading_Invoices.mp4`,
  },
  {
    category: "platform-guide",
    title: "Platform Training Guides",
    name: "Finding Curating Properties",
    type: "video",
    url: `${BASE_URL}/1_Platform_Training_Guides/Finding_Curating_Properties.mp4`,
  },
  {
    category: "platform-guide",
    title: "Platform Training Guides",
    name: "Managing Your Agency Account",
    type: "video",
    url: `${BASE_URL}/1_Platform_Training_Guides/Managing_Your_Agency_Account.mp4`,
  },
  {
    category: "platform-guide",
    title: "Platform Training Guides",
    name: "Sharing Properties Setting Your Commission",
    type: "video",
    url: `${BASE_URL}/1_Platform_Training_Guides/Sharing_Properties_Setting_Your_Commission.mp4`,
  },
  {
    category: "platform-guide",
    title: "Platform Training Guides",
    name: "Tracking Earnings Getting Paid",
    type: "video",
    url: `${BASE_URL}/1_Platform_Training_Guides/Tracking_Earnings_Getting_Paid.mp4`,
  },

  // Client Marketing Materials
  {
    category: "client-marketing",
    title: "Promotional Flyers",
    name: "SSC Advantage.pdf",
    type: "pdf",
    url: `${BASE_URL}/2_Client_Marketing_Materials/1_Promotional_Flyers/SSC_Advantage.pdf`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 1.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_1.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 2.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_2.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 3.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_3.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 4.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_4.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 5.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_5.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 6.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_6.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 7.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_7.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 8.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_8.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 9.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_9.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 10.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_10.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 11.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_11.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 12.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_12.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 13.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_13.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 14.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_14.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 15.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_15.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 16.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_16.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 17.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_17.jpg`,
  },
  {
    category: "client-marketing",
    title: "Web Banners",
    name: "Web Banners 18.jpg",
    type: "image",
    url: `${BASE_URL}/2_Client_Marketing_Materials/2_Web_Banners/Web_Banner_18.jpg`,
  },

  // Webinars Assets & Recordings
  {
    category: "webinars",
    title: "Webinars",
    name: "Recorded Disney Webinar",
    type: "video",
    url: `${BASE_URL}/3_Webinars/1_Disney/Recorded_Disney_Webinar.mp4`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "SSC Disney Amenity and Theme Requests 3.pdf",
    type: "pdf",
    url: `${BASE_URL}/3_Webinars/1_Disney/SSC_Disney_Amenity_and_Theme_Requests_3.pdf`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "SSC Disney Webinar.pptx",
    type: "pdf",
    url: `${BASE_URL}/3_Webinars/1_Disney/SSC_Disney_Webinar.pptx.pdf`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "Recorded Luxury Webinar",
    type: "video",
    url: `${BASE_URL}/3_Webinars/2_Luxury/Recorded_Luxury_Webinar.mp4`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "SSC Luxury Webinar.pptx",
    type: "pdf",
    url: `${BASE_URL}/3_Webinars/2_Luxury/SSC_Luxury_Webinar.pptx.pdf`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "Large Group Property Handout.pdf",
    type: "pdf",
    url: `${BASE_URL}/3_Webinars/3_Big_Groups/Large_Group_Property_Handout.pdf`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "Large Groups Presentation.pdf",
    type: "pdf",
    url: `${BASE_URL}/3_Webinars/3_Big_Groups/Large_Groups_Presentation.pdf`,
  },
  {
    category: "webinars",
    title: "Webinars",
    name: "Large Groups Webinar",
    type: "video",
    url: `${BASE_URL}/3_Webinars/3_Big_Groups/Large_Groups_Webinar.mp4`,
  },
]
